var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle0, _circle1, _circle10;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgLoader = (_ref, ref) => {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    style: {
      margin: "auto",
      background: "#fff",
      display: "block"
    },
    width: "200px",
    height: "200px",
    viewBox: "0 0 100 100",
    preserveAspectRatio: "xMidYMid",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 75,
    cy: 50,
    fill: "#5699d2",
    r: 5
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    values: "3;3;5;3;3",
    times: "0;0.1;0.2;0.3;1",
    dur: "1s",
    repeatCount: "indefinite",
    begin: "-0.9166666666666666s"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill",
    values: "#5699d2;#5699d2;#1d3f72;#5699d2;#5699d2",
    repeatCount: "indefinite",
    times: "0;0.1;0.2;0.3;1",
    dur: "1s",
    begin: "-0.9166666666666666s"
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 71.65063509461098,
    cy: 62.5,
    fill: "#5699d2",
    r: 5
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    values: "3;3;5;3;3",
    times: "0;0.1;0.2;0.3;1",
    dur: "1s",
    repeatCount: "indefinite",
    begin: "-0.8333333333333334s"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill",
    values: "#5699d2;#5699d2;#1d3f72;#5699d2;#5699d2",
    repeatCount: "indefinite",
    times: "0;0.1;0.2;0.3;1",
    dur: "1s",
    begin: "-0.8333333333333334s"
  }))), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 62.5,
    cy: 71.65063509461096,
    fill: "#5699d2",
    r: 5
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    values: "3;3;5;3;3",
    times: "0;0.1;0.2;0.3;1",
    dur: "1s",
    repeatCount: "indefinite",
    begin: "-0.75s"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill",
    values: "#5699d2;#5699d2;#1d3f72;#5699d2;#5699d2",
    repeatCount: "indefinite",
    times: "0;0.1;0.2;0.3;1",
    dur: "1s",
    begin: "-0.75s"
  }))), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 75,
    fill: "#5699d2",
    r: 5
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    values: "3;3;5;3;3",
    times: "0;0.1;0.2;0.3;1",
    dur: "1s",
    repeatCount: "indefinite",
    begin: "-0.6666666666666666s"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill",
    values: "#5699d2;#5699d2;#1d3f72;#5699d2;#5699d2",
    repeatCount: "indefinite",
    times: "0;0.1;0.2;0.3;1",
    dur: "1s",
    begin: "-0.6666666666666666s"
  }))), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 37.50000000000001,
    cy: 71.65063509461098,
    fill: "#5699d2",
    r: 5
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    values: "3;3;5;3;3",
    times: "0;0.1;0.2;0.3;1",
    dur: "1s",
    repeatCount: "indefinite",
    begin: "-0.5833333333333334s"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill",
    values: "#5699d2;#5699d2;#1d3f72;#5699d2;#5699d2",
    repeatCount: "indefinite",
    times: "0;0.1;0.2;0.3;1",
    dur: "1s",
    begin: "-0.5833333333333334s"
  }))), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 28.34936490538903,
    cy: 62.5,
    fill: "#5699d2",
    r: 5
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    values: "3;3;5;3;3",
    times: "0;0.1;0.2;0.3;1",
    dur: "1s",
    repeatCount: "indefinite",
    begin: "-0.5s"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill",
    values: "#5699d2;#5699d2;#1d3f72;#5699d2;#5699d2",
    repeatCount: "indefinite",
    times: "0;0.1;0.2;0.3;1",
    dur: "1s",
    begin: "-0.5s"
  }))), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 50,
    fill: "#5699d2",
    r: 5
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    values: "3;3;5;3;3",
    times: "0;0.1;0.2;0.3;1",
    dur: "1s",
    repeatCount: "indefinite",
    begin: "-0.4166666666666667s"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill",
    values: "#5699d2;#5699d2;#1d3f72;#5699d2;#5699d2",
    repeatCount: "indefinite",
    times: "0;0.1;0.2;0.3;1",
    dur: "1s",
    begin: "-0.4166666666666667s"
  }))), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 28.34936490538903,
    cy: 37.50000000000001,
    fill: "#5699d2",
    r: 5
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    values: "3;3;5;3;3",
    times: "0;0.1;0.2;0.3;1",
    dur: "1s",
    repeatCount: "indefinite",
    begin: "-0.3333333333333333s"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill",
    values: "#5699d2;#5699d2;#1d3f72;#5699d2;#5699d2",
    repeatCount: "indefinite",
    times: "0;0.1;0.2;0.3;1",
    dur: "1s",
    begin: "-0.3333333333333333s"
  }))), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 37.499999999999986,
    cy: 28.349364905389038,
    fill: "#5699d2",
    r: 5
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    values: "3;3;5;3;3",
    times: "0;0.1;0.2;0.3;1",
    dur: "1s",
    repeatCount: "indefinite",
    begin: "-0.25s"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill",
    values: "#5699d2;#5699d2;#1d3f72;#5699d2;#5699d2",
    repeatCount: "indefinite",
    times: "0;0.1;0.2;0.3;1",
    dur: "1s",
    begin: "-0.25s"
  }))), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    cx: 49.99999999999999,
    cy: 25,
    fill: "#5699d2",
    r: 5
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    values: "3;3;5;3;3",
    times: "0;0.1;0.2;0.3;1",
    dur: "1s",
    repeatCount: "indefinite",
    begin: "-0.16666666666666666s"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill",
    values: "#5699d2;#5699d2;#1d3f72;#5699d2;#5699d2",
    repeatCount: "indefinite",
    times: "0;0.1;0.2;0.3;1",
    dur: "1s",
    begin: "-0.16666666666666666s"
  }))), _circle1 || (_circle1 = /*#__PURE__*/React.createElement("circle", {
    cx: 62.5,
    cy: 28.349364905389034,
    fill: "#5699d2",
    r: 5
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    values: "3;3;5;3;3",
    times: "0;0.1;0.2;0.3;1",
    dur: "1s",
    repeatCount: "indefinite",
    begin: "-0.08333333333333333s"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill",
    values: "#5699d2;#5699d2;#1d3f72;#5699d2;#5699d2",
    repeatCount: "indefinite",
    times: "0;0.1;0.2;0.3;1",
    dur: "1s",
    begin: "-0.08333333333333333s"
  }))), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 71.65063509461096,
    cy: 37.499999999999986,
    fill: "#5699d2",
    r: 5
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    values: "3;3;5;3;3",
    times: "0;0.1;0.2;0.3;1",
    dur: "1s",
    repeatCount: "indefinite",
    begin: "0s"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill",
    values: "#5699d2;#5699d2;#1d3f72;#5699d2;#5699d2",
    repeatCount: "indefinite",
    times: "0;0.1;0.2;0.3;1",
    dur: "1s",
    begin: "0s"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLoader);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/loader.12e644ff2d55609bd2878930ddeda139.svg";